import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { GroupImportsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createGroupImport = (data, redirect = undefined): any => action(types.CREATE_GROUP_IMPORT_REQUESTED, { data, redirect });

export const updateGroupImport = (data): any => action(types.UPDATE_GROUP_IMPORT_REQUESTED, data);

export const deleteGroupImport = (groupImportId): any => action(types.UPDATE_GROUP_IMPORT_REQUESTED, groupImportId);

export const getGroupImport = (groupImportId): any => action(types.GET_GROUP_IMPORT_REQUESTED, groupImportId);

export const getAllGroupImports = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_GROUP_IMPORTS_REQUESTED, {
  pagination,
  compile,
});

export const selectGroupImport = (groupImportId): any => action(types.SELECT_GROUP_IMPORT_REQUESTED, {
  currentGroupImportId: groupImportId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createGroupImportPending: (payload): any => action(types.CREATE_GROUP_IMPORT_PENDING, payload),
  createGroupImportSuccess: (response): any => {
    const currentGroupImport = response.entities.groupImports[response.result];
    // history.push(`/payment/${currentGroupImport.paymentCollection.id}/review`);
    return action(types.CREATE_GROUP_IMPORT_SUCCESS, {
      groupImportsById: response.entities.groupImports,
      currentGroupImportId: response.result,
    });
  },
  createGroupImportFailed: (error): any => action(types.CREATE_GROUP_IMPORT_FAIL, { backendErrors: error }),
  updateGroupImportPending: (payload): any => action(types.UPDATE_GROUP_IMPORT_PENDING, payload),
  updateGroupImportSuccess: (response): any => action(types.UPDATE_GROUP_IMPORT_SUCCESS, {
    groupImportsById: response.entities.groupImports,
    currentGroupImportId: response.result,
  }),
  updateGroupImportFailed: (error): any => action(types.UPDATE_GROUP_IMPORT_FAIL, { backendErrors: error }),
  deleteGroupImportPending: (): any => action(types.UPDATE_GROUP_IMPORT_PENDING, {}),
  deleteGroupImportSuccess: (response, userId): any => {
    localStorage.set(userId, { currentGroupImportId: null });
    history.push('/groupImports');

    return action(types.DELETE_GROUP_IMPORT_SUCCESS, {
      currentGroupImportId: response,
    });
  },
  getGroupImportPending: (): any => action(types.GET_GROUP_IMPORT_PENDING, {}),
  getGroupImportSuccess: (response): any => action(types.GET_GROUP_IMPORT_SUCCESS, {
    groupImportsById: response.entities.groupImports,
    currentGroupImportId: response.result,
  }),
  getGroupImportFailed: (error): any => action(types.GET_GROUP_IMPORT_FAIL, { backendErrors: error }),
  deleteGroupImportFailed: (error): any => action(types.UPDATE_GROUP_IMPORT_FAIL, { backendErrors: error }),
  getAllGroupImportsPending: (pagination): any => action(types.GET_ALL_GROUP_IMPORTS_PENDING, { pagination }),
  getAllGroupImportsSuccess: (response, meta): any => action(types.GET_ALL_GROUP_IMPORTS_SUCCESS, {
    groupImportsById: response.entities.groupImports,
    groupImportIds: response.result,
    meta,
  }),
  getAllGroupImportsFailed: (error): any => action(types.GET_ALL_GROUP_IMPORTS_FAIL, { backendErrors: error }),
};

export default null;
